export default __webpack_public_path__ + "media/images/images_v2/onglet-gauche-cafe2e209b502e3670df78c4f683d4ab.png";